// extracted by mini-css-extract-plugin
export default {"overlayLoader":"loading-overlay--overlayLoader","loadingAnim":"loading-overlay--loadingAnim","overlayLoader_Msg":"loading-overlay--overlayLoader_Msg","fade":"loading-overlay--fade"};